import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroPurchaseOrderFieldsSection', {
    contactFieldTitle: 'Contact',
    contactFieldPlaceholder: 'Select a Supplier',
    dateFieldTitle: 'Date',
    dateFieldPlaceholder: 'Enter the date',
    deliveryDateFieldTitle: 'Delivery Date',
    deliveryDateFieldPlaceholder: 'Enter the date',
    referenceFieldTitle: 'Reference',
    referenceFieldPlaceholder: 'Enter the Reference',
    themeFieldTitle: 'Theme',
    themeFieldPlaceholder: 'Select the theme',
    addContactButton: '+ New contact',
    multipleContactsWarning: 'Multiple contacts detected. Check suggested contacts.',
});
